'use client'

import { useQuery } from '@tanstack/react-query'
import {
  fetchAdminOverview,
  type AdminOverviewParams,
} from '@/features/admin/api/admin-overview.api'
import { useApiFetch } from '@/features/auth'
import { queryKeys } from '@/lib/queryKeys'

export function useAdminOverview(params: AdminOverviewParams = {}) {
  const authedFetch = useApiFetch()
  return useQuery({
    queryKey: queryKeys.admin.overview(params),
    queryFn: () => fetchAdminOverview(authedFetch, params),
  })
}
